import { filter as _filter } from 'lodash';

class UserController {
  constructor(authService, enums) {
    "ngInject";

    this.authService = authService;

    if(!authService.validateUser(false)) { return; }

    this.locations = _filter(authService.authData.userRoles, o => o.entityType === enums.ENTITY_TYPE.Location);

    if (this.locations.length && !authService.authData.currentLocationId) {
      authService.authData.currentLocationId = this.locations[0].entityId.toString();
    }
  }
}

export default UserController;



// WEBPACK FOOTER //
// ./client/app/components/user/user.controller.js